import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/public/optimized/background.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/dashboard-sidebar-trophy.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/american-football.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/aussie-rules.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/badminton.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/bandy.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/baseball.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/basketball.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/beach-volleyball.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/cricket.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/darts.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/esports.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/floorball.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/football.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/futsal.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/handball.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/hockey.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/rugby.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/snooker.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/table-tennis.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/tennis.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/volleyball.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/icons/waterpolo.webp");
import(/* webpackMode: "eager" */ "/app/public/optimized/live.webp");
import(/* webpackMode: "eager" */ "/app/public/svg/moresports.svg");
import(/* webpackMode: "eager" */ "/app/src/components/PlanetServer.tsx")